import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppMaterialModule } from '../app-material.module';
import { MarginalsModule } from '../marginals/marginals.module';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { AuthRoutingModule } from './auth.routing.module';
import { LoginComponent } from './components/login/login.component';
import { LoginFreshDeskComponent } from './components/loginfreshdesk/loginfreshdesk.component';
import { LogoutfreshdeskComponent } from './components/logoutfreshdesk/logoutfreshdesk.component';
import { CellPhoneUpdateDialogComponent } from './components/mfa/cellphone-update-dialog/cellphone-update-dialog.component';
import { CellphoneValidationComponent } from './components/mfa/phone-validation/cellphone-validation.component';
import { LoginHeaderComponent } from './components/login-header/login-header.component';
import { PipesModule } from '../pipes/pipes.module';
import { EmailLinkValidationComponent } from './components/mfa/email-link-validation/email-link-validation.component';
import { SharedDirectiveModule } from '../shared-directives/shared-directives.module';
import { MessageComponent } from './components/message/message.component';

@NgModule({
    declarations: [
        LoginComponent,
        LoginFreshDeskComponent,
        LogoutfreshdeskComponent,
        CellPhoneUpdateDialogComponent,
        CellphoneValidationComponent,
        LoginHeaderComponent,
        EmailLinkValidationComponent,
        MessageComponent
    ],
    imports: [
        AuthRoutingModule,
        AppMaterialModule,
        CommonModule,
        FlexLayoutModule,
        FormsModule,
        MarginalsModule,
        ReactiveFormsModule,
        SharedComponentsModule,
        RouterModule,
        SharedDirectiveModule,
        PipesModule
    ],
    exports: [
        LogoutfreshdeskComponent,
        CellphoneValidationComponent,
        EmailLinkValidationComponent,
        LoginHeaderComponent,
        CellPhoneUpdateDialogComponent,
        MessageComponent
    ]
})
export class AuthModule { }
